// extracted by mini-css-extract-plugin
export default {"nav":"navbar_nav__9yobq","navbar":"navbar_navbar__AFivn","logo":"navbar_logo__mwD3t","DesktopOnly":"navbar_DesktopOnly__Z1QBo"};